import { type InjectionKey, type MaybeRefOrGetter } from "vue";

export const localeInjectionKey: InjectionKey<MaybeRefOrGetter<string>> =
	Symbol("locale");
